import cogoToast from 'cogo-toast';
import api from './apiURL';
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// Get Anonymous Token
export const fetchAnonymousToken = createAsyncThunk(
    'auth/fetchAnonymousToken',
    async (_, thunkAPI) => {
      const { rejectWithValue } = thunkAPI;
      try {
        const res = await fetch( api + '/api/v1/request-anonymous-token', {
            method: 'POST',
            body: '',
            headers: {
            'Content-type': 'application/json; charset=UTF-8',
            },
        });
        const data = await res.json();
        
        return data ;
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
);

// Get Refresh Token
export const fetchRefreshToken = createAsyncThunk(
  'auth/fetchRefreshToken',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await fetch( api + '/api/v1/refresh-token', {
          method: 'POST',
          body: '',
          headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("refreshToken")}`,
          },
      });
      const data = await res.json();
      
      return data ;
    } catch (error) {
      
      return rejectWithValue(error.message);
    }
  }
);

// Login Request
export const requestLogin = createAsyncThunk(
    'auth/requestLogin',
    async (loginData, thunkAPI) => {
      
      const { rejectWithValue } = thunkAPI;

      try {
        const res = await fetch( api + '/api/v1/login', {
          method: 'POST',
          body: JSON.stringify(loginData),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const data = await res.json();
        return data;
        
      } catch (error) {
        console.log(error);
        return rejectWithValue(error.message);
      }
    }
  );

// Register Request
export const requestRegister = createAsyncThunk(
  'auth/requestRegister',
  async (registerData, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/register', {
        method: 'POST',
        body: JSON.stringify(registerData),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

const AuthSlice = createSlice({
    name: "auth",
    initialState: {
        loading: false,
        error: null,
        loggedIn: false,
        tokenReady: false,
        hasErrors: false,
        errorObject:[],
        // registerBtnDisabled: true,
        userObject: {
            userId: '',
            token: '',
            refreshToken: ''
        },
        userDetails: {
          userId: '',
          token: '',
          refreshToken: '',
          firstName: '',
          lastName: '',
          email: '',
          mobile: '',
      },
    },
    reducers: {},
    extraReducers: {
      [fetchAnonymousToken.pending]: (state, action) => {
          state.loading = true;
          state.error = null;
      },
      [fetchAnonymousToken.fulfilled]: (state, action) => {
          state.loading = false;
          state.loggedIn = false;
          state.tokenReady = true;
          state.userObject = action.payload;
          localStorage.setItem('token', action.payload.token);
          localStorage.setItem('refreshToken', action.payload.refreshToken);
          // cogoToast.success("Anonymous Token Success", {position: "bottom-left"});
      },
      [fetchAnonymousToken.rejected]: (state, action) => {
          state.loading = false;
          state.loggedIn = false;
          state.error = action.payload;
          // cogoToast.error("Anonymous Token Failed", {position: "bottom-left"});
      },

      //Refresh Token Request  
      [fetchRefreshToken.pending]: (state, action) => {
        state.loading = true;
        state.error = null;
      },
      [fetchRefreshToken.fulfilled]: (state, action) => {
        if (action.payload.success === false){
          state.isRefresh = false;
          // cogoToast.error("Refresh Token Failed", {position: "bottom-left"});
        }else{
          state.userObject = action.payload;
          state.isRefresh = true;
          state.tokenReady = true;
          localStorage.setItem('token', action.payload.token);
          localStorage.setItem('refreshToken', action.payload.refreshToken);
          // cogoToast.success("Refresh Token Success", {position: "bottom-left"});
        }
          
      },
      [fetchRefreshToken.rejected]: (state, action) => {
          // state.loading = false;
          // state.loggedIn = false;
          state.isRefresh = false;
          state.error = action.payload;
          // cogoToast.error("Refresh Token Failed", {position: "bottom-left"});
      },


      //Login Request  
      [requestLogin.pending]: (state, action) => {
          state.loading = true;
          state.error = null;
      },
      [requestLogin.fulfilled]: (state, action) => {

          state.loading = false;
          state.userDetails = action.payload;
          if (action.payload.success === false){
            state.loggedIn = false;

            cogoToast.error("Login Failed: "+ action.payload.message , {position: "bottom-left"});
          }
          else{
            state.loggedIn = true;
            state.tokenReady = true;
            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('refreshToken', action.payload.refreshToken);
            
            
            cogoToast.success("Login Success", {position: "bottom-left"});
          }
          
      },
      [requestLogin.rejected]: (state, action) => {
          state.loading = false;
          state.loggedIn = false;
          state.error = action.payload;
          
          
          cogoToast.error("Login Failed", {position: "bottom-left"});
      },


      //Register Request  
      [requestRegister.pending]: (state, action) => {
          state.loading = true;
          state.error = null;
      },
      [requestRegister.fulfilled]: (state, action) => {
          
          state.loading = false;
          state.userDetails = action.payload;
          if ( action.payload.errors || action.payload.success === false){
            state.loggedIn = false;
            console.log(action.payload);
            state.errorObject = action.payload.errors;
            state.hasErrors = true;
            cogoToast.error("Register Error" , {position: "bottom-left"});
          }
          else if (action.payload.success !== false){
            state.loggedIn = true;
            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('refreshToken', action.payload.refreshToken);
            state.hasErrors = false;
            
            cogoToast.success("Register Success", {position: "bottom-left"});
          }
          
      },
      [requestRegister.rejected]: (state, action) => {
          state.loading = false;
          state.loggedIn = false;
          state.error = action.payload;

          cogoToast.error("Register Failed", {position: "bottom-left"});
      },
    },
});

//export const { addToCompare, deleteFromCompare } = authSlice.actions;
export default AuthSlice.reducer;
